import React, { useState, useRef, useEffect } from "react";
import JoditEditor from "jodit-react";
import projectServices from "../project/services/projectServices";
import { createNotification } from "../helpers/Notification";
import Loader from "../common/Loader";
import { Tab } from "react-bootstrap";
import { DropDown } from "../common";
import SimpleReactValidator from 'simple-react-validator';
import ConfirmBox from "../common/ConfirmBox";
// import './index.css'
const SmsEditor = (props) => {
  const editor = useRef(null);
  const [subject, setSubject] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [customMsg, setCustomMsg] = useState("");
  const [content, setContent] = useState("");
  const [email, setEmail] = useState("");
  const [currentTab, setCurrentTab] = useState("custom");
  const [loader, setLoader] = useState(false);
  const [templateDropdown, setTemplateDropdown] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [backLocation, setBackLocation] = useState("");
  const [groupName, setGroupName] = useState("");
  const [individualName, setIndividualName] = useState("");
  const [isMail, setIsMail] = useState(false);


  useEffect(() => {
    // console.log("props",props);
    setLoader(true);
    handleEmail();
  });

  const handleEmail = () => {
    // console.log("props",props);
    if (!props.email == "") {
      // console.log("props email",props.phoneNumber);
      setIndividualName(props.name);
      setPhoneNumber(props.phoneNumber);
      setEmail(props.email);
      setBackLocation(props.backLocation);
      setGroupName(props.name);
      
    } else if (!props.phoneNumber == ""){
      // console.log("props phone num ",props.phoneNumber);
      setIndividualName(props.name);
      setPhoneNumber(props.phoneNumber);
      setBackLocation(props.backLocation);
      setGroupName(props.name);

    }
    setLoader(false);
  };

  const config = {
    Placeholder: "Start Typing",
  };

  const form = useRef();

  const handleReset = () => {
    setCustomMsg("");
    setContent("");
    setSelectedTemplate(0);
  };
  const handleSendEmail = (e) => {
    // console.log("customMsg",customMsg);
    // console.log("content",content);
    const finalMessage = customMsg === '' ?  content: customMsg;
    
    const sanitizedContent = finalMessage.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, "").trim();
    e.preventDefault();
    // console.log("sanitizedContent",sanitizedContent);
    
    let payload = {
      subject: subject,
      content: sanitizedContent,
    };
    // console.log("payload",payload);

    // if (payload.subject ==''){
    //   createNotification("error"," Please add subject");
    // } else
    //  {
      if(backLocation == 'Single'){
        // console.log("isMail",isMail);
        projectServices
      // .sendMail(email, payload)
      .sendIndividualMail(email,isMail, payload)
      .then((response) => {
        console.log("reponse",response);
        if (response.status === 200) {
          createNotification("success", response.data.message);
          handleReset();
        }
      })
      .catch((error) => {
        console.log(error);
      });

      } else {
        // console.log("isMail",isMail);
        projectServices
      // .sendMail(email, payload)
      .sendGroupMail(email,isMail, payload)
      .then((response) => {
        if (response.status === 200) {
          createNotification("success",  response.data.message);
          handleReset();
        }
      })
      .catch((error) => {
        console.log(error);
      });
      }
    // }
  };

  const handleFormChange = (e) => {
    // console.log("handleFormChange",e.target.value);
    setCustomMsg(e.target.value);
    // validator.showMessages(); 
    // setForceUpdate((prev) => prev + 1); 
  };

  const handleTabs = (e) => {
    if (e.target.id === "custom") {
      setCurrentTab("custom");
    } else {
      getDropdownData();
      setCurrentTab("template");
    }
  };
  const getDropdownData = () => {
    projectServices
      .getTemplateList()
      .then((response) => {
        let responseData = response.data.data;
        let listArr = [];
        responseData &&
          responseData.map((item) => {
            listArr.push({ lable: item.subject, value: item.id });
          });
        setTemplateDropdown(listArr);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          createNotification("error", "Your login session has expired .");
          props.history.push("/login");
        }
      });
  };

  const handleOnChange = (e) => {
    if (e.target.value == 0) {
      setContent("");
      setSelectedTemplate(e.target.value);
      
    } else {
      
      setSelectedTemplate(e.target.value);
      getTemplayeById(e.target.value);
      setLoader(true);
    }
  };

  const getTemplayeById = (id) => {
    if(!id == 0) {
      projectServices
      .getTemplateDetailsById(id)
      .then((response) => {
        // console.log("response",response.data.content);
        if (response.status === 200) {
          // console.log("response inside",response.data.content);
          setLoader(false);
          setContent(response.data.content);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    } else  if (id == 0 ){
      setContent('')
    }
   
  };
  return (
    <>
      {phoneNumber.length == 0 ? (
        <div style={{ marginLeft: "20px" }}>
          <h4 style={{ color: "red" }}>
            {" "}
            Please add phone number for this user and try again !
          </h4>
        </div>
      ) : (
        ""
      )}
      <div>
        {loader == true ? (
          <Loader />
        ) : ( 
          <> 
          <form ref={form} onSubmit={handleSendEmail} className="editorForm">
            <div className="form-group" style={{ width: 800, marginBottom:20 }}>
              <label>
                To : {backLocation === "Group" ? ` Group - ${groupName} `
                 :
                  (<>{individualName} - {phoneNumber} </>)}
              </label>
            </div>
            
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a
                  id="custom"
                  class={
                    currentTab == "custom" ? "nav-link active" : "nav-link"
                  }
                  aria-current="page"
                  href="#"
                  onClick={handleTabs}
                >
                  Custom
                </a>
              </li>
              <li class="nav-item">
                <a
                  id="template"
                  class={
                    currentTab == "template" ? "nav-link active" : "nav-link"
                  }
                  href="#"
                  onClick={handleTabs}
                >
                  Template
                </a>
              </li>
            </ul>
            {currentTab == "custom" ? (
              <div className="form-group" style={{ width: 780 }}>
                <label>Message :</label>
                <textarea
                style={{
                    border: "1px solid lightgrey",
                    borderRadius: "5px",
                    height: "150px",
                    maxWidth:"680px"
                  }}
                className="form-control"
                type="text"
                name="customMsg"
                onChange={handleFormChange}
                value={customMsg}
              />

                {/* {validator.message(
                "Message",
                content,
                "required",
                { className: "text-danger" }
              )} */}
              </div>
            ) : (
              <div
                className="selectTemplate"
                style={{
                  maxWidth: "800px",
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  height: "250px",
                  padding: "10px",
                }}
              >
                <div className="project-filter-dropdown mb-3 align-items-center">
                  <DropDown
                    name="titleId"
                    firstOption={{ lable: "Select template", value: 0 }}
                    options={templateDropdown}
                    onChange={(e) => handleOnChange(e)}
                    defaultSelected={selectedTemplate}
                    lable=""
                    value={selectedTemplate}
                  />
                </div>
                <div>
                  <label>Message :</label>
                  <p> {content} </p>
                </div>
              </div>
            )}

            <div className="form-group" style={{ width: 700, marginTop: 10 }}>
              <input
                type="submit"
                value="Send SMS"
                className="btn btn-primary waves-effect waves-light"
                disabled={backLocation === "Group" ? false : (phoneNumber == "")}
              />
            </div>
          </form>
          </>
        )}
      </div>
    </>
  );
};

export default SmsEditor;
